import Heading from "@elements/Typography/Heading";
import useSwrApi from "@hooks/useSwrApi";
import { JobListingMap } from "@typings/HomePagePayloadType";
import { twMerge } from "tailwind-merge";

type JobsListingProps = {
  jobs?: JobListingMap;
};

const JobsCard = ({
  imgUrl,
  title,
  url,
  count,
}: {
  imgUrl: string;
  title: string;
  url: string;
  count: string;
}) => {
  return (
    <a
      className="flex gap-2.5 w-full lg:w-[calc(50%-5px)] bg-[white]"
      href={url}
    >
      <img
        alt={title}
        height={88}
        width={123}
        src={imgUrl}
        className="max-h-24 w-31 h-auto"
      />
      <div className="flex-col">
        <p
          className={twMerge(
            "font-bold font-primary text-red-100 text-xs leading-300",
          )}
        >
          {title}
        </p>
        <p
          className={twMerge(
            "font-medium font-primary text-base lg:text-xs leading-300",
          )}
        >
          {count} jobs
        </p>
      </div>
    </a>
  );
};

export const JobsListing = ({ jobs }: JobsListingProps) => {
  let jobsData = jobs;
  if (!jobs) {
    const { data: jobsListingMap } =
      // eslint-disable-next-line react-hooks/rules-of-hooks
      useSwrApi<JobListingMap>(`jobs-listing`);
    jobsData = jobsListingMap;
  }
  const jobsList = jobsData
    ? Object.keys(jobsData).map((mapKey: string) => jobsData[mapKey])
    : [];
  return (
    <div className="lg:mt-md pb-5 border-b border-pink-300">
      <Heading
        Element="h2"
        className="text-gray-100 text-2.5md font-bold mb-md"
      >
        சிங்கப்பூர் வேலைகள்
      </Heading>
      <div className="flex flex-col justify-center bg-gray-500">
        <div className="flex justify-between flex-wrap p-xs gap-2.5">
          {jobsList.map((job, index) => (
            <JobsCard
              count={job.totaljob}
              url={job.url}
              key={index}
              imgUrl={job.img_url}
              title={job.tamil_title}
            />
          ))}
        </div>
        <a
          className={twMerge(
            "m-auto font-bold font-primary text-base text-red-100 lg:text-2sm leading-300 pb-100 hover:underline hover:cursor-pointer hover:text-red-200",
          )}
          href="/jobs"
        >
          எல்லா வேலைகளையும் காண்க
        </a>
      </div>
    </div>
  );
};
